import React, { useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  IconButton,
  Grid,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { postNotification } from "../utilities/Notifications";
import { BCPXmark } from "../icons/bcp/BCPIcons";
import { postData } from "../utilities/UtilityFunctions";

export default function ExportModal(props) {
  const {
    label,

    exportTypes,
    setExportTypes,

    circuit,
    event,
    setLoading,
    open,
    setOpen,
    authContext
  } = props;
  const [email, setEmail] = useState(authContext?.authState?.identity?.email);
  const [error, setError] = useState(null);
  const validateEmail = (emailList) => {
    if (emailList === "") {
      setError("Required");
      return false;
    } else {
      var emails = emailList.replace(/\s/g, "").split(",");
      var valid = true;
      var regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      for (var i = 0; i < emails.length; i++) {
        if (emails[i] === "" || !regex.test(emails[i])) {
          valid = false;
        }
      }
      if (!valid) {
        setError("Invalid email list");
        return false;
      } else {
        setError(null);
        return true;
      }
    }
  };
  const handleChange = (e) => {
    if (email !== e.target.value) {
      setEmail(e.target.value);
      validateEmail(e.target.value);
    } else {
      validateEmail(email);
    }
  };

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          //minHeight: "95vh",
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              {label || "Export Settings"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="email"
              label="Email"
              value={email}
              variant="outlined"
              fullWidth
              margin="normal"
              onBlur={handleChange}
              onChange={handleChange}
              error={Boolean(error)}
              helperText={error}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={async () => {
                if (!validateEmail(email)) {
                  postNotification("error", "Please enter a valid email list");
                  return false;
                }
                setLoading(true);

                try {
                  var body = {
                    email: email
                  };
                  if (exportTypes) {
                    body.exportTypes = exportTypes;
                    await postData(
                      `/${circuit ? "leagues" : "events"}/${circuit ? circuit.id : event.id}/export`,
                      { body: body }
                    );
                    if (setExportTypes) setExportTypes(null);

                    postNotification(
                      "success",
                      "Your export has been emailed, please check your email"
                    );
                  } else {
                    throw new Error("Invalid export type");
                  }
                } catch (err) {
                  postNotification("error", err);
                }

                setLoading(false);
                setOpen(false);
              }}
            >
              Export
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
